import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import { Merge } from 'common/utility-types';

import { selectContentBeforeWrap } from '../selectContentBeforeWrap';
import { InputSize } from '../types';

import './Input.less';

export type InputProps = Merge<
  React.InputHTMLAttributes<HTMLInputElement>,
  {
    plain?: boolean;
    className?: string;
    disabled?: boolean;
    hideArrows?: boolean;
    error?: boolean;
    selectOnFocus?: boolean;
    variant?: InputSize;
  }
>;

const block = bemBlock('neptune-input');

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  {
    className,
    disabled,
    hideArrows,
    error,
    selectOnFocus,
    plain,
    variant = 'medium',
    onFocus,
    ...props
  },
  ref,
) {
  const classNames = block({
    modifiers: {
      plain,
      disabled,
      'hide-arrows': hideArrows,
      error,
      variant,
    },
    extra: className,
  });

  return (
    <input
      {...props}
      ref={ref}
      className={classNames}
      disabled={disabled}
      onFocus={selectOnFocus ? selectContentBeforeWrap(onFocus) : onFocus}
      data-is-invalid={error}
    />
  );
});
